/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Dry_Needling_TermsInputs */

const en_service_type_dry_needling_terms = /** @type {(inputs: Service_Type_Dry_Needling_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dry needling, needles, needling`)
};

const pl_service_type_dry_needling_terms = /** @type {(inputs: Service_Type_Dry_Needling_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`igłowanie, dry needling, igły, igłoterapia`)
};

/**
* | output |
* | --- |
* | "dry needling, needles, needling" |
*
* @param {Service_Type_Dry_Needling_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_dry_needling_terms = /** @type {((inputs?: Service_Type_Dry_Needling_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Dry_Needling_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_dry_needling_terms(inputs)
	return en_service_type_dry_needling_terms(inputs)
});